import { Injectable } from '@angular/core';
import {
    AutocompleteStrategy,
    BaseFilterStategy,
    CheckboxGroupRangeStrategy,
    CheckboxGroupStrategy,
    DateFieldStrategy,
    DateRangeFieldStrategy,
    DateTimeRangeFieldStrategy,
    InputNumberRangeStrategy,
    MultiselectAutocompleteStrategy,
    NumberInputStrategy,
    ExternalFilterStrategy,
    StringInputStrategy,
    TodayCheckBoxStrategy
} from './filter-strategy';
import { FilterCriteria, FilterLabelsType } from '../../models/filterServiceTypes';
import { CheckboxGroupType, RangePicker } from '@nagel-types';
import { FilterOperatorType } from '../configuration/consts/filterStrategiesConsts';

@Injectable({
    providedIn: 'root'
})
export class FilterFieldMapperService {
    filterStrategies: (BaseFilterStategy<FilterCriteria> | BaseFilterStategy<FilterCriteria[]>)[];

    constructor() {
        this.filterStrategies = [
            new ExternalFilterStrategy(),
            new NumberInputStrategy(),
            new DateFieldStrategy(),
            new TodayCheckBoxStrategy(),
            new DateRangeFieldStrategy(),
            new DateTimeRangeFieldStrategy(),
            new AutocompleteStrategy(),
            new MultiselectAutocompleteStrategy(),
            new StringInputStrategy(),
            new InputNumberRangeStrategy(),
            new CheckboxGroupStrategy(),
            new CheckboxGroupRangeStrategy()
        ];
    }

    private getStrategy = (type: string, key: string) => {
        return this.filterStrategies.find(currentStrategy => {
            return currentStrategy.isApplicable(type as string, key);
        });
    };

    getHelperText = (type: string, value: unknown, labelsMap?: FilterLabelsType): string => {
        let result = '';

        const strategy = this.getStrategy(type, '');

        if (strategy) {
            result = strategy.getValuesHelperText(value, labelsMap);
        }

        return result;
    };

    generateFilterCriteria = (
        filterFields: Record<string, unknown>,
        fieldTypes: Record<string, unknown>,
        operatorMap?: Record<string, FilterOperatorType>
    ) => {
        return Object.entries(filterFields).reduce<FilterCriteria[]>((acc, [key, value]) => {

            const strategy = this.getStrategy(fieldTypes[key as keyof typeof fieldTypes] as string, key);

            const operatorToUse = operatorMap?.[key] || null;

            if (strategy && strategy.shouldAddFilter(value)) {
                const appliedStrategy = strategy.applyStrategy(
                    key,
                    value as string & RangePicker & CheckboxGroupType & {from: string, to: string} & DateTimeRangeFieldStrategy,
                    operatorToUse
                );

                Array.isArray(appliedStrategy)
                    ? acc.push(...appliedStrategy)
                    : acc.push(appliedStrategy);
            }


            return acc;
        }, []);
    };
}